import california1 from '../../assets/images/bg/california1_bw_sm.jpg'; 
import california2 from '../../assets/images/bg/california2_bw_sm.jpg'; 
import california3 from '../../assets/images/bg/california3_bw_sm.jpg'; 
import california4 from '../../assets/images/bg/california4_bw_sm.jpg'; 
import california5 from '../../assets/images/bg/california5_bw_sm.jpg'; 
import california6 from '../../assets/images/bg/california6_bw_sm.jpg'; 
import monterrey1 from '../../assets/images/bg/monterrey1_bw_sm.jpg'; 
import monterrey2 from '../../assets/images/bg/monterrey2_bw_sm.jpg'; 
import newmexico3 from '../../assets/images/bg/newmexico3_bw_sm.jpg'; 
import oaxaca1 from '../../assets/images/bg/oaxaca1_bw_sm.jpg'; 
import oaxaca2 from '../../assets/images/bg/oaxaca2_bw_sm.jpg'; 
import oaxaca3 from '../../assets/images/bg/oaxaca3_bw_sm.jpg'; 
import oaxaca4 from '../../assets/images/bg/oaxaca4_bw_sm.jpg'; 
import oaxaca5 from '../../assets/images/bg/oaxaca5_bw_sm.jpg'; 
import oaxaca6 from '../../assets/images/bg/oaxaca6_bw_sm.jpg'; 
import oaxaca7 from '../../assets/images/bg/oaxaca7_bw_sm.jpg'; 
import oaxaca8 from '../../assets/images/bg/oaxaca8_bw_sm.jpg'; 
import oaxaca9 from '../../assets/images/bg/oaxaca9_bw_sm.jpg'; 
import oaxaca10 from '../../assets/images/bg/oaxaca10_bw_sm.jpg'; 
import oaxaca11 from '../../assets/images/bg/oaxaca11_bw_sm.jpg'; 
import oaxaca12 from '../../assets/images/bg/oaxaca12_bw_sm.jpg'; 
import oaxaca13 from '../../assets/images/bg/oaxaca13_bw_sm.jpg'; 
import oaxaca14 from '../../assets/images/bg/oaxaca14_bw_sm.jpg'; 
import texas from '../../assets/images/bg/texas_bw_sm.jpg'; 
import utah from '../../assets/images/bg/utah_bw_sm.jpg'; 

export const IMAGES = [
  california1,
  california2,
  california3,
  california4,
  california5,
  california6,
  monterrey1,
  monterrey2,
  newmexico3,
  oaxaca1,
  oaxaca2,
  oaxaca3,
  oaxaca4,
  oaxaca5,
  oaxaca6,
  oaxaca7,
  oaxaca8,
  oaxaca9,
  oaxaca10,
  oaxaca11,
  oaxaca12,
  oaxaca13,
  oaxaca14,
  texas,
  utah
];